import { ROUTES } from '@/shared/config'
import { ContentWrapper, HeaderContent } from '@/shared/ui'
import { JingleCollectionForm } from '@/widgets/JingleCollectionForm'
import { Breadcrumb, Layout } from 'antd'
import { Link } from 'react-router-dom'

import { JingleCollectionCreatePageGate } from './model/jingle-collection-create.model'

export const JingleCollectionCreatePage = () => {
  return (
    <Layout>
      <JingleCollectionCreatePageGate />
      <HeaderContent
        breadcrumbSlot={
          <Breadcrumb
            items={[
              { title: 'Джинглы' },
              {
                title: <Link to={ROUTES.JINGLES.COLLECTIONS}>Подборки</Link>,
              },
              {
                title: 'Создание подборки',
              },
            ]}
          />
        }
        title="Создание подборки"
        description="Раздел позволяет создать подборку джинглов"
      />

      <ContentWrapper>
        <JingleCollectionForm />
      </ContentWrapper>
    </Layout>
  )
}
